export const COMPANY_SETTINGS = 'company_settings';
